/* eslint-disable import/no-cycle */
import * as API from './api';

import * as UTILS from './utils';

const ProjectModel = { ...API, ...UTILS };

export default ProjectModel;
